import { useQuery } from '@tanstack/react-query';
import { enumDefinitionsApi } from '@/api/services/enumDefinitions';
import type { Select2Option } from '@/components/forms/Select2';

// Enum display labels come from the backend (ABP EnumHelper.GetDisplayName) and
// never change within a session, so cache them forever keyed by the sorted names.
export function useEnumOptions(names: string[]) {
  const sorted = [...names].sort();
  const query = useQuery({
    queryKey: ['enum-definitions', sorted],
    queryFn: () => enumDefinitionsApi.getEnums(sorted),
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return {
    options: query.data ?? ({} as Record<string, Select2Option[]>),
    isLoading: query.isLoading,
  };
}

// Convenience: fetch a single enum's options.
export function useEnum(name: string): Select2Option[] {
  const { options } = useEnumOptions([name]);
  return options[name] ?? [];
}
